export interface IMasterDataDeductionCategory {
  categoryId: number;
  categoryName: string;
  categoryKey: string;
  isActive: boolean;
  isLinked: boolean;
  createdAt: string | null;
  createdBy: number | null;
}

export class MasterDataDeductionCategory {
  private readonly _categoryId: number;
  private readonly _categoryName: string;
  private readonly _categoryKey: string;
  private readonly _isActive: boolean;
  private readonly _isLinked: boolean;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;

  constructor(props: IMasterDataDeductionCategory) {
    this._categoryId = props.categoryId;
    this._categoryName = props.categoryName;
    this._categoryKey = props.categoryKey;
    this._isActive = props.isActive;
    this._isLinked = props.isLinked;
    this._createdAt = props.createdAt;
    this._createdBy = props.createdBy;
  }

  get categoryId(): number {
    return this._categoryId;
  }
  get categoryName(): string {
    return this._categoryName;
  }
  get categoryKey(): string {
    return this._categoryKey;
  }
  get isActive(): boolean {
    return this._isActive;
  }
  get isLinked(): boolean {
    return this._isLinked;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get createdBy(): number | null {
    return this._createdBy;
  }

  static from(props: IMasterDataDeductionCategory): MasterDataDeductionCategory {
    return new MasterDataDeductionCategory(props);
  }

  static toJSON(
    entity: MasterDataDeductionCategory,
  ): IMasterDataDeductionCategory {
    return {
      categoryId: entity.categoryId,
      categoryName: entity.categoryName,
      categoryKey: entity.categoryKey,
      isActive: entity.isActive,
      isLinked: entity.isLinked,
      createdAt: entity.createdAt,
      createdBy: entity.createdBy,
    };
  }
}

export interface IMasterDataDeductionCategoryDeleteResult {
  deletedCount: number;
  blockedCount: number;
  blockedIds: number[];
  message: string | null;
}
